import { Component, inject, input, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { AuthService } from '@auth0/auth0-angular'
import { LoadingSpinnerComponent } from 'src/app/shared/components/loading-spinner/loading-spinner.component'

@Component({
    selector: 'sf-callback',
    imports: [LoadingSpinnerComponent],
    templateUrl: './callback.component.html',
    styleUrl: './callback.component.scss',
})
export class CallbackComponent implements OnInit {
    #authService = inject(AuthService)
    #router = inject(Router)

    error = input('')

    ngOnInit(): void {
        // this.#authService.handleRedirectCallback().subscribe({
        //     next: (state) => {
        //         this.#router.navigateByUrl(state?.appState?.target ?? '/customers')
        //     },
        //     error: (error) => {
        //         if (error.error === 'access_denied') {
        //             this.#router.navigate(['/access-denied'], {
        //                 queryParams: { message: error.error_description ?? 'Access denied' },
        //             })
        //         } else {
        //             this.#router.navigate(['/error'], {
        //                 queryParams: { message: error.error_description ?? 'Login failed' },
        //             })
        //         }
        //     },
        // })
    }
}
